import { Configurer } from '../Core/index';
import { Zpfs_hdfs } from './Zpfs_hdfs';

/**Upload service with local HDFS storage*/
export class Zpfs_hdfsConfigurer extends Configurer {
  /**
   * User HTTP api for files
   *
   * User API for file upload and download.
   * */
}
